"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgMarker(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 0C301.8 0 130.7 172.1 130.7 383.6c0 72.3 15.1 147.8 45 224.3 28.2 72.2 69.4 145.4 122.6 217.5 36.6 49.6 80.1 99.5 119.4 136.9 43 40.9 74.8 61.7 94.2 61.7 19.5 0 51.2-20.8 94.2-61.7 39.3-37.4 82.9-87.3 119.4-136.9 53.2-72.1 94.4-145.3 122.6-217.5 29.9-76.5 45-152 45-224.3C893.3 172.1 722.2 0 512 0zm41 893.7c-14.2 13.2-27.3 24.3-38 32.2-10.7-7.9-23.8-19-38-32.2-38.1-35.3-78.2-80-113.1-126-101-133.2-154.4-267.9-154.4-389.4 0-164.7 137.1-298.7 305.5-298.7s305.5 134 305.5 298.7c0 121.5-53.4 256.1-154.4 389.4-34.9 46-75.1 90.7-113.1 126zm-53.2-705.4c-99.7 0-180.8 85.3-180.8 190.1s81.1 190.1 180.8 190.1 180.8-85.3 180.8-190.1-81.1-190.1-180.8-190.1zm2 299.5c-55.8 0-101.2-45.4-101.2-101.2S446 285.5 501.8 285.5 603 330.9 603 386.7s-45.5 101.1-101.2 101.1z"
  }));
}

var ForwardRef = React.forwardRef(SvgMarker);
var _default = ForwardRef;
exports.default = _default;